<div class="layout-footer">
    <div >
        <img src="assets/images/logo.png" alt="Logo" class="h-10 object-contain" />
    </div>
    <span class="footer-copyright">&#169; tessi - 2026</span>
</div>
